import PrivateNotesApi from '../api/PrivateNotesApi';
import PrivateNotesConstants from '../constants/PrivateNotesConstants';

function addPrivateNote({ metadataId, note, postSuccess }) {
  return {
    metadataId,
    postSuccess,
    types: [
      PrivateNotesConstants.ADD_PRIVATE_NOTES_REQUEST,
      PrivateNotesConstants.ADD_PRIVATE_NOTES_SUCCESS,
      PrivateNotesConstants.ADD_PRIVATE_NOTES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => PrivateNotesApi.addPrivateNote({
      metadataId,
      note,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function updatePrivateNote({ metadataId, noteId, note, postSuccess }) {
  return {
    metadataId,
    noteId,
    postSuccess,
    types: [
      PrivateNotesConstants.UPDATE_PRIVATE_NOTES_REQUEST,
      PrivateNotesConstants.UPDATE_PRIVATE_NOTES_SUCCESS,
      PrivateNotesConstants.UPDATE_PRIVATE_NOTES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => PrivateNotesApi.updatePrivateNote({
      noteId,
      note,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removePrivateNote({ metadataId, noteId, postSuccess }) {
  return {
    metadataId,
    noteId,
    postSuccess,
    types: [
      PrivateNotesConstants.REMOVE_PRIVATE_NOTES_REQUEST,
      PrivateNotesConstants.REMOVE_PRIVATE_NOTES_SUCCESS,
      PrivateNotesConstants.REMOVE_PRIVATE_NOTES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => PrivateNotesApi.removePrivateNote({
      noteId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.privateNotes.${noteId}`]
    })
  };
}

export default {
  addPrivateNote,
  updatePrivateNote,
  removePrivateNote
};



// WEBPACK FOOTER //
// ./app/actions/PrivateNotesActions.js